import { ORDERED_CHANGELOG_TYPES } from './MsiChangelog.helpers';

export const SET_CHANGELOG_STATE = 'venuepage/autosync/msichangelog/SET_CHANGELOG_STATE';
export const setChangelogState = ({ changelogType, page }) => ({
  type: SET_CHANGELOG_STATE,
  changelogType,
  page,
});

export const defaultState = {
  changelogType: ORDERED_CHANGELOG_TYPES[0],
  page: 1,
};

const reducer = (state = defaultState, { type, ...action }) => {
  switch (type) {
    case SET_CHANGELOG_STATE:
      return { ...state, changelogType: action.changelogType, page: action.page };
    default:
      return state;
  }
};

export default reducer;
